/**
 * LiquidMetal, version: 1.0 (2011-12-17)
 *
 * A mimetic poly-alloy of Quicksilver's scoring algorithm, essentially
 * LiquidMetal.
 *
 * For usage and examples, visit:
 * http://github.com/rmm5t/liquidmetal
 *
 * Licensed under the MIT:
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright (c) 2009-2012, Ryan McGeary (ryan -[at]- mcgeary [*dot*] org)
 *
 * @deprecated, use SimpleSearch
 */
var LiquidMetal = (function() {
  var SCORE_NO_MATCH = 0.0;
  var SCORE_MATCH = 1.0;
  var SCORE_TRAILING = 0.8;
  var SCORE_TRAILING_BUT_STARTED = 0.9;
  var SCORE_BUFFER = 0.85;

  return {
    score: function(string, abbreviation) {
      // Short circuits
      if (abbreviation.length === 0) return SCORE_TRAILING;
      if (abbreviation.length > string.length) return SCORE_NO_MATCH;

      var scores = this.buildScoreArray(string, abbreviation);

      // complete miss:
      if ( scores === false )  return 0;

      var sum = 0.0;
      for (var i = 0; i < scores.length; i++) {
        sum += scores[i];
      }

      return (sum / scores.length);
    },

    buildScoreArray: function(string, abbreviation) {
      var scores = new Array(string.length);
      var lower = string.toLowerCase();
      var chars = abbreviation.toLowerCase();

      var lastIndex = -1;
      var started = false;
      for (var i = 0; i < chars.length; i++) {
        var c = chars[i];
        var index = lower.indexOf(c, lastIndex+1);

        if (index === -1) return false; // signal no match
        if (index === 0) started = true;

        if (isNewWord(string, index)) {
          scores[index-1] = 1;
          fillArray(scores, SCORE_BUFFER, lastIndex+1, index-1);
        }
        else if (isUpperCase(string, index)) {
          fillArray(scores, SCORE_BUFFER, lastIndex+1, index);
        }
        else {
          fillArray(scores, SCORE_NO_MATCH, lastIndex+1, index);
        }

        scores[index] = SCORE_MATCH;
        lastIndex = index;
      }

      var trailingScore = started ? SCORE_TRAILING_BUT_STARTED : SCORE_TRAILING;
      fillArray(scores, trailingScore, lastIndex+1, scores.length);
      return scores;
    }
  };

  function isUpperCase(string, index) {
    var c = string.charAt(index);
    return ("A" <= c && c <= "Z");
  }

   function isNewWord(string, index) {
    var c = string.charAt(index-1);
    return (c == " " || c == "\t");
  }

  function fillArray(array, value, from, to) {
    for (var i = from; i < to; i++) { array[i] = value; }
    return array;
  }
})();

var SimpleSearch = (function() {
  return {
    score: function(string, abbreviation) {
      var score = 0;
      if(string.toLowerCase().indexOf(abbreviation.toLowerCase()) != -1) score = 1;
      return score;
    }
  }
})();

/**
 * flexselect: a jQuery plugin, version: 0.3 (2011-12-17)
 * @requires jQuery v1.3 or later
 *
 * FlexSelect is a jQuery plugin that makes it easy to convert a select box into
 * a Quicksilver-style, autocompleting, flex matching selection tool.
 *
 * For usage and examples, visit:
 * http://rmm5t.github.com/jquery-flexselect/
 *
 * Licensed under the MIT:
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright (c) 2009-2012, Ryan McGeary (ryan -[at]- mcgeary [*dot*] org)
 *
 * Patched by @sap1ens
 */
(function($) {
  $.flexselect = function(select, options) { this.init(select, options); };

  $.extend($.flexselect.prototype, {
    settings: {
      allowMismatch: false,
      selectedClass: "flexselect_selected",
      dropdownClass: "flexselect_dropdown",
      inputIdTransform:    function(id)   { return id + "_flexselect"; },
      inputNameTransform:  function(name) { return; },
      dropdownIdTransform: function(id)   { return id + "_flexselect_dropdown"; },
      charsForStart: 0,
      sortAlphabetically: false,
      disableSort: false,
      preSelection: true
    },
    select: null,
    input: null,
    hidden: null,
    dropdown: null,
    dropdownList: null,
    cache: [],
    results: [],
    lastAbbreviation: null,
    abbreviationBeforeFocus: null,
    selectedIndex: 0,
    picked: false,
    dropdownMouseover: false, // Workaround for poor IE behaviors
	firstShown: true,
	firstLetterTyped: false,
    stopEvents: false,

    init: function(select, options) {
      this.settings = $.extend({}, this.settings, options);
      this.select = $(select);
      this.preloadCache();
      this.renderControls();
      this.wire();
    },

    preloadCache: function() {
      this.cache = this.select.children("option").map(function() {
        return { name: $.trim($(this).text()), value: $(this).val(), score: 0.0 };
      });
    },

    renderControls: function() {
      var selected = this.settings.preSelection ? this.select.find("option:selected") : null;
	  var selectedText = selected ? $.trim(selected.text()) : '';
      if (this.settings.disableSort) this.selectedIndex = selected? selected.index() : 0;

      this.hidden = $("<input type='hidden'/>").attr({
          id: this.select.attr("id"),
          name: this.select.attr("name")
      });

      this.input = $("<input type='text' autocomplete='off' />").attr({
          id: this.settings.inputIdTransform(this.select.attr("id")),
          name: this.settings.inputNameTransform(this.select.attr("name")),
          accesskey: this.select.attr("accesskey"),
          tabindex: this.select.attr("tabindex"),
          style: this.select.attr("style")
      }).addClass(this.select.attr("class"));

      if (selected != null) {
        this.hidden.val(selected.val());

        this.hidden.data("origin-value", selected.val());

        this.input.val(selectedText).css({
          visibility: 'visible'
        });

        this.input.data("origin-text", selectedText);
      }

      this.select.after(this.input).after(this.hidden).remove();
    },

    wire: function() {
      var self = this;

      this.input.click(function() {
      	self.firstLetterTyped = false;
        self.lastAbbreviation = null;
        self.focus();
      });

//      I don't know why we need this
//      this.input.mouseup(function(event) {
//        // This is so Safari selection actually occurs.
//        event.preventDefault();
//      });

      this.input.focus(function() {
      	self.hideOtherElements();

        self.abbreviationBeforeFocus = self.input.val();
        //self.input.select();
        //if (!self.picked) self.filterResults();
        self.firstShown = true;
        self.stopEvents = true;
        self.filterResults();
      });

      this.input.blur(function() {
        self.hide();
        if (!self.settings.allowMismatch && !self.isInputTextAllowed()) self.reset();
        self.firstLetterTyped = false;
      });

      this.input.keyup(function(event) {
        switch (event.keyCode) {
          case 13: // return
            event.preventDefault();
            self.pickSelected();
            self.focusAndHide();
            break;
          case 27: // esc
            event.preventDefault();
            self.reset();
            self.focusAndHide();
            self.input.blur();
            break;
          default:
          	if(self.stopEvents) {
          	  self.stopEvents = false;
          	  return;
          	}
            self.firstShown = false;
            self.filterResults();
            break;
        }
      });

      this.input.keydown(function(event) {
        switch (event.keyCode) {
          case 9:  // tab
            self.hide();
            break;
          case 33: // pgup
            event.preventDefault();
            self.stopEvents = true;
            self.markFirst();
            break;
          case 34: // pgedown
            event.preventDefault();
            self.stopEvents = true;
            self.markLast();
            break;
          case 38: // up
            event.preventDefault();
            self.stopEvents = true;
            self.moveSelected(-1);
            break;
          case 40: // down
            event.preventDefault();
            self.stopEvents = true;
            self.moveSelected(1);
            break;
          case 13: // return
            if (event.shiftKey) { // hack: allow hotkeys for Document Entry UI
              return true;
            }
            event.preventDefault();
            event.stopPropagation();
            break;
          case 91: // cmd
            return true; // hack: allow hotkeys for Document Entry UI
            break;
          case 27: // esc
          case 16: // shift
            event.preventDefault();
            event.stopPropagation();
            break;
          case 83: // s
            if (event.metaKey || event.ctrlKey) { // hack: allow hotkeys for Document Entry UI
              return true;
              break;
            }
          // keep this fall-through
          default:
            if(!self.firstLetterTyped && !self.settings.allowMismatch) {
          	  self.input.val("");
          	  self.firstLetterTyped = true;
          	}
          break;
        }
      });

      this.input.bind("destroy", function() {
      	if(self.dropdown) self.dropdown.remove();
      	self.input.remove();
      	self.hidden.remove();
      });
    },

    filterResults: function() {
      var abbreviation = this.input.val();
      if((abbreviation.length < this.settings.charsForStart) || (this.settings.charsForStart != 0 && this.firstShown)) {
      	return;
      }
      //if (abbreviation == this.lastAbbreviation) return;

      var self = this;

      var results = [];
      $.each(this.cache, function() {
        this.score = SimpleSearch.score(this.name, abbreviation);
        if (self.firstShown || this.score > 0.0) results.push(this);
      });
      this.results = results;

      this.sortResults();
      this.createDropdown();
      this.renderDropdown();

      if(this.settings.disableSort) {
        this.moveSelected(0);
      } else {
        this.markFirst();
      }

      this.lastAbbreviation = abbreviation;
      this.picked = false;
    },

    sortResults: function() {
      if(this.settings.disableSort) {
        return this.results;
      }

      if(this.settings.sortAlphabetically) {
	    this.results.sort(function(a, b) {
	      if(a.name < b.name) return -1;
	      if(a.name > b.name) return 1;
	      return 0;
	    });
      } else {
      	this.results.sort(function(a, b) {
      		return b.score - a.score;
      	});
      }
    },

    createDropdown: function() {
      var id = this.settings.dropdownIdTransform(this.hidden.attr("id"));
      if($("#" + id).length) return;

      this.dropdown = $("<div></div>").attr({
        id: id
      }).addClass(this.settings.dropdownClass);
      this.dropdownList = $("<ul></ul>");
      this.dropdown.append(this.dropdownList);

      $("body").append(this.dropdown);

      var self = this;

      this.dropdownList.mouseover(function (event) {
        if (event.target.tagName == "LI") {
          var rows = self.dropdown.find("li");
          self.markSelected(rows.index($(event.target)));
        }
      });
      this.dropdownList.mouseleave(function () {
        self.markSelected(-1);
      });
      this.dropdownList.mouseup(function (event) {
        self.pickSelected();
        self.focusAndHide();
      });
      this.dropdown.mouseover(function (event) {
        self.dropdownMouseover = true;
      });
      this.dropdown.mouseleave(function (event) {
        self.dropdownMouseover = false;
      });
      this.dropdown.mousedown(function (event) {
        event.preventDefault();
      });
    },

    renderDropdown: function() {
      var dropdownBorderWidth = this.dropdown.outerWidth(false) - this.dropdown.innerWidth();
      var inputOffset = this.input.offset();

      this.dropdown.css({
        width: (this.input.outerWidth(false) - dropdownBorderWidth) + "px",
        top: (inputOffset.top + this.input.outerHeight()) + "px",
        left: inputOffset.left + "px"
      });

      var list = this.dropdownList.html("");

      if(this.results.length == 0) {
      	this.dropdown.hide();
      	return;
      }

      $.each(this.results, function() {
        // list.append($("<li/>").html(this.name + " <small>[" + Math.round(this.score*100)/100 + "]</small>"));
        list.append($("<li/>").html(this.name));
      });
      this.dropdown.show();
    },

    markSelected: function(n) {
      if (n > this.results.length || !this.dropdown) return;

      var rows = this.dropdown.find("li");
      rows.removeClass(this.settings.selectedClass);
      this.selectedIndex = n;

      if (n >= 0) $(rows[n]).addClass(this.settings.selectedClass);
    },

    pickSelected: function() {
      var selected = this.results[this.selectedIndex];
      if (selected) {
        this.input.val(selected.name);
        this.input.data("origin-text", selected.name);
        this.hidden.val(selected.value);
        this.hidden.data("origin-value", selected.value);
        this.picked = true;
      } else if (this.settings.allowMismatch) {
        this.hidden.val("");
      } else if(this.selectedIndex != -1) {
        this.reset();
      }

      this.hidden.trigger("change");
      this.input.trigger("dropdownPicked");
    },

    isInputTextAllowed: function() {
    	var text = this.input.val();
    	var allowed = false;

        $.each(this.cache, function() {
          if(text === this.name) allowed = true;
        });

        return allowed;
    },

    hide: function() {
      if(this.dropdown) this.dropdown.remove();
      this.lastAbbreviation = null;
      this.input.trigger("removeHighlight");
    },

    hideOtherElements: function() {
      $(".flexselect_dropdown").remove();
    },

    moveSelected: function(n) { this.markSelected(this.selectedIndex+n); },
    markFirst:    function()  { this.markSelected(0); },
    markLast:     function()  { this.markSelected(this.results.length - 1); },
    reset:        function()  {
      if(this.settings.allowMismatch) {
      	this.input.val(this.abbreviationBeforeFocus);
      } else {
      	this.input.val(this.input.data("origin-text"));
        this.hidden.val(this.hidden.data("origin-value"));
      }
    },
    focus:        function()  { this.input.focus(); },
    focusAndHide: function()  { this.focus(); this.hide(); this.markSelected(-1); }
  });

  $.fn.flexselect = function(options) {
    this.each(function() {
      if (this.tagName == "SELECT") new $.flexselect(this, options);
    });
    return this;
  };
})(jQuery);
